export default "__VITE_ASSET__BpXN7YEN__"